module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDJkZWQzNWFhMmFhYzg1N2FjODQwODU2YWM4NDVkMmIucG5nIjs="